import {Action, Selector, State, StateContext} from '@ngxs/store';
import {Injectable} from '@angular/core';
import {BaseService, DataBaseServiceResponse} from '../../services/base-service/base.service';
import {environment} from '../../../environments/environment';
import {firstValueFrom} from 'rxjs';
import {MiniSphereNamespace} from '../../namespaces/mini-sphere.namespace';


export interface IRMiniSphere {
  miniSphere: MiniSphereNamespace.IMiniSphere;
}

export namespace RecordMiniSphereAction {
  export class GetActive {
    static readonly type: string = '[Record] Get Record Mini Sphere Action';
    constructor(
      public serviceId: string,
      public patientId: string
    ) { }
  }

  export class PatchActive {
    static readonly type: string = '[Record] Patch Record Mini Sphere Action';
    constructor(
      public serviceId: string,
      public patientId: string,
      public miniSphereId: string,
      public data: Partial<MiniSphereNamespace.IMiniSphere>
    ) { }
  }
}

@State<IRMiniSphere>({
  name: 'MiniSphereState',
  defaults: {
    miniSphere: null,
  },
})
@Injectable()
export class MiniSphereState {
  constructor(
    private baseService: BaseService<any>,
  ) { }

  url: string = environment.SERVER_URL;

  @Selector()
  public static getRecordMiniSphere(
    state: IRMiniSphere
  ): MiniSphereNamespace.IMiniSphere {
    return state.miniSphere;
  }

  @Action(RecordMiniSphereAction.GetActive)
  async getRecordMedicalPersonalAction(
    ctx: StateContext<IRMiniSphere>,
    action: RecordMiniSphereAction.GetActive
  ): Promise<void> {
    const response: DataBaseServiceResponse<MiniSphereNamespace.IMiniSphere> = await firstValueFrom(
      this.baseService.get(`${this.url}/patients/${action.patientId}/service/${action.serviceId}/records/mini-sphere`)
    );

    if (response.error) throw new Error(response.message);

    ctx.patchState({
      miniSphere: response.entity,
    });
  }

  @Action(RecordMiniSphereAction.PatchActive)
  async patchRecordMedicalPersonalAction(
    ctx: StateContext<IRMiniSphere>,
    action: RecordMiniSphereAction.PatchActive
  ): Promise<void> {
    const response: DataBaseServiceResponse<void> = await firstValueFrom(
      this.baseService.patch(`${this.url}/patients/${action.patientId}/service/${action.serviceId}/records/mini-sphere/${action.miniSphereId}`, action.data)
    );

    if (response.error) throw new Error(response.message);
  }
}
